import useTranslation from 'next-translate/useTranslation';
import { IconSize } from 'src/interfaces/Icon';
import { FullScreenEnterIcon, FullScreenLeaveIcon } from '../../icons';
import { IFullScreenEnterIcon } from '../../icons/FullScreenIcons/FullScreenEnterIcon';
import IconButton from '../IconButton';
import TooltipWrapper from '../TooltipWrapper';

export interface IFullscreenControlProps {
  onClick: VoidFunction;
  active: boolean;
  iconSize?: IFullScreenEnterIcon['size'];
  className?: string;
}

const FullScreenControl = ({ onClick, active, className, iconSize = IconSize.large }: IFullscreenControlProps) => {
  const { t } = useTranslation('common');
  const tooltipText = active ? t('tooltips.full_screen.inactive') : t('tooltips.full_screen.active');

  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='top'>
      <IconButton
        data-testid='fullscreen-control'
        onClick={onClick}
        className={className}
        icon={
          active ? (
            <FullScreenLeaveIcon data-testid='full_screen_leave' size={iconSize} />
          ) : (
            <FullScreenEnterIcon data-testid='full_screen_enter' size={iconSize} />
          )
        }
      />
    </TooltipWrapper>
  );
};

export default FullScreenControl;
